const automationRoutes = {
  path: "automation",
  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Automation/index");
        const Automation = mod.default;
        return { Component: Automation };
      },
    },
    {
      path: "templates",
      lazy: async () => {
        const mod = await import("views/Admin/Automation/automation-templates");
        const AutomationTemplates = mod.default;
        return { Component: AutomationTemplates };
      },
    },
    {
      // Reached from the "Create automation → Select from template" flow:
      // picking a card creates a new automation, and manage actions are hidden.
      path: "templates/use",
      lazy: async () => {
        const mod = await import("views/Admin/Automation/automation-templates");
        const AutomationTemplates = mod.default;
        return { Component: () => <AutomationTemplates createMode /> };
      },
    },
    {
      path: ":id/analytics",
      lazy: async () => {
        const mod = await import("views/Admin/Automation/automation-analytics");
        const AutomationAnalytics = mod.default;
        return { Component: AutomationAnalytics };
      },
    },
  ],
};

export default automationRoutes;
